var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5H15C15.831 2.5 16.5 3.169 16.5 4V7.75H0V4C0 3.169 0.669 2.5 1.5 2.5Z",
    fill: "url(#paint0_linear_6662_8227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.0742V7.19922H16V18.0742C16 18.7368 15.5179 19.1992 15 19.1992H1.5C0.982071 19.1992 0.5 18.7368 0.5 18.0742Z",
    fill: "white",
    stroke: "#FAB251"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.25C4.5 0.835786 4.16421 0.5 3.75 0.5C3.33579 0.5 3 0.835786 3 1.25V4.25C3 4.66421 3.33579 5 3.75 5C4.16421 5 4.5 4.66421 4.5 4.25V1.25Z",
    fill: "#FBBB51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.25C13.5 0.835786 13.1642 0.5 12.75 0.5C12.3358 0.5 12 0.835786 12 1.25V4.25C12 4.66421 12.3358 5 12.75 5C13.1642 5 13.5 4.66421 13.5 4.25V1.25Z",
    fill: "#FBB951"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5H12V11H13.5V9.5Z",
    fill: "#FAB251"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5H9V11H10.5V9.5Z",
    fill: "#FAB251"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.5H6V11H7.5V9.5Z",
    fill: "#FAB251"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H3V11H4.5V9.5Z",
    fill: "#FAB251"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5H12V14H13.5V12.5Z",
    fill: "#FAB251"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5H9V14H10.5V12.5Z",
    fill: "#FAB251"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H6V14H7.5V12.5Z",
    fill: "#FAB251"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.5H3V14H4.5V12.5Z",
    fill: "#FAB251"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5H9V17H10.5V15.5Z",
    fill: "#FAB251"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5H6V17H7.5V15.5Z",
    fill: "#FAB251"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5H3V17H4.5V15.5Z",
    fill: "#FAB251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6662_8227",
    x1: 7.92985,
    y1: 0.421875,
    x2: 7.92985,
    y2: 7.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAA52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.6636ecb58d5658f454b5068e89445c79.svg";
export { ForwardRef as ReactComponent };